// extracted by mini-css-extract-plugin
module.exports = {"response":"Documentation_response__XXNTJ","objectFormat":"Documentation_objectFormat__10PPY"};